<template>
  <div class="responseMain" ref="container">
    <SearchForm v-model="keyWord" placeholder="请输入手机号"></SearchForm>
    <isEmpty v-if="orderList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          暂时没有问题反馈
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">
        <div class="before">
          全部反馈
        </div>
        <div class="after">
          待反馈
          <span>
          {{
              orderList.filter((item) => item.state === "待处理").length
            }}
        </span>
        </div>

      </div>
      <mu-load-more
          @refresh="refresh"
          :refreshing="refreshing"
          :loaded-all="loaded_all"
          :loading="loading"
          @load="load"
      >
        <div class="list-item"
             v-for="(item, index) in orderList"
             @click="onClick(item)"
             :key="`list-item_${index}`">
          <div class="header-info">
            <div class="before">
              <div class="time">{{ item.createTime || '-' }}</div>
              <div class="title">{{ item.type || "其他原因" }}</div>
            </div>
            <div class="state"
                 :class="item.state === '待处理' ? 'state-N' : 'state-Y'"
            >{{ item.state }}
            </div>
          </div>
          <div class="data-box">
            <div class="data-item">
              <div class="before">
                用户手机号：
              </div>
              <div class="after">
                {{ item.mobile || '-' }}
              </div>
            </div>
            <div class="data-item">
              <div class="before">
                设备名称：
              </div>
              <div class="after">
                {{ item.pkname || '-' }}
              </div>
            </div>
            <div class="data-item">
              <div class="before">
                充电桩编码：
              </div>
              <div class="after">
                {{ item.deviceNo || '-' }}
              </div>
            </div>
            <div class="data-item">
              <div class="before">
                问题描述：
              </div>
              <div class="after">
                {{ item.rmk || '-' }}
              </div>
            </div>
          </div>
        </div>
      </mu-load-more>
    </div>
  </div>
</template>
<script>
import {getFeedBackList} from "@/api/newApi";
import {Toast} from "vant";

export default {
  data() {
    return {
      deviceNo: "",
      startTime: "",
      endTime: "",
      type: "",
      state: null,
      num: 1,
      loaded_all: false,
      refreshing: false,
      loading: false,
      text: "List",
      nolist: true,
      orderList: [],
      keyWord: null,
      pages: 0,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    keyWord: function (v) {
      this.pages = 1;
      this.orderList = [];
      this.getList();
    },
    orderList: function (v) {
      if (v == "") {
        this.nolist = true;
      } else {
        this.nolist = false;
      }
    },
  },
  methods: {
    onClick(item) {
      this.$router.push({
        path: "/admin/responseDetail",
        query: {id: item.id, state: item.state},
      });
    },
    getList() {
      getFeedBackList({
        pageNo: this.num,
        pageSize: 9999,
        state: this.state,
        keyWord: this.keyWord,
      }).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            this.pages = res.data.pages;
            res.data.records.forEach((item) => {
              this.orderList.push(item);
            });
            this.nolist = false;
            if (res.data.pages == this.num) {
              Toast("已加载全部数据");
              this.loaded_all = true;
            }
          }
        } else {
          this.orderList = [];
          Toast("暂无数据");
        }
      });
    },
    showchoosediv() {
      this.$refs.responsechoose.Showchoosediv();
    },
    shaixu(somedata) {
      (this.type = somedata.type),
          (this.startTime = somedata.stime),
          (this.endTime = somedata.etime),
          (this.state = somedata.state),
          this.getList();
    },
    single(id, state) {
      this.$router.push({
        path: "/admin/response-single/" + id,
      });
    },
    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.pages = 1;
        this.orderList = [];
        this.getList();
      }, 1000);
    },

    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          if (this.deviceNo != "") {
            this.getList();
          } else {
            this.getList();
          }
        }
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.responseMain {
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;


  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #666666;

      .before {
        font-size: $fontSize_14;
      }

      .after {
        font-size: $fontSize_12;
        span{
          color: #2B69F7;
        }
      }

      //position: relative;
    }

    span {
      color: #3D3D3D;
      margin-left: 0.1rem;
      font-weight: bold;
    }

    .list-item {
      margin-bottom: 0.3rem;
      border-radius: $borderRadius;
      background-color: white;
      padding: $divPadding;

      .header-info {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid #ECECEC;
        position: relative;

        .before {
          .time {
            color: #999999;
            font-size: $fontSize_12;
          }

          .title {
            color: #444444;
            font-size: $fontSize_14;
            font-weight: bold;
            margin-top: 0.2rem;
          }
        }

        .state {
          padding: 0.1rem 0.2rem;
          font-size: $fontSize_10;
          border-radius: 0.054rem;
          position: absolute;
          bottom: 0.7rem;
          right: 0
        }

        .state-N {
          background-color: #FBE8D2;
          color: #F1942F;
        }

        .state-Y {
          background-color: #E8F3FF;
          color: #165DFF;
        }

      }

      .data-box {
        margin-top: $divPadding;

        .data-item {
          display: flex;
          padding-bottom: 0.2rem;
          font-size: $fontSize_12;

          &:last-child {
            padding-bottom: 0;
          }

          .before {
            color: #999999;
          }

          .after {
            color: #666666;
          }
        }
      }
    }

  }

}
</style>
